import React from "react";

const About = () => (
  <section className="inner container px-3 px-lg-5" id="about-section">
    <div>
      <h2 className="section-title">ABOUT</h2>
      <p>
        I've always been an internet enthusiast. I recall my mother and I
        walking up to the library and me being amazed with the access to my
        desired content on demand. Growing up it was necessary for me to keep up
        with the latest technology, and these were some factors to why I knew I
        could find fulfillment in web development. Since taking the path to
        become a fullstack developer, I've created websites for small
        businesses, large financial institutions, and non-profit organizations.
        I am always up to the task of mastering new technology and love to
        assist new learners. Thank you for visiting and I appreciate your time.
      </p>
    </div>
  </section>
);

export default About;
